import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CardCarousel from '@homeaway/react-card-carousel';
import { AspectRatioCard } from '@homeaway/react-aspect-ratio-card';
import IsBrowser from '../IsBrowser';

import './Carousel.less';

class Carousel extends Component {
  static propTypes = {
    title: PropTypes.string,
    onPreviousClick: PropTypes.func,
    onNextClick: PropTypes.func,
    isTouchDevice: PropTypes.bool,
    cardAspectRatio: PropTypes.string
  }

  static defaultProps = {
    title: '',
    cardAspectRatio: '4x3',
    onPreviousClick: () => {},
    onNextClick: () => {}
  }

  constructor(props) {
    super(props);

    this.state = {
      index: 0
    };
  }

  handlePrevNext = cb => (evt, newIndex) => {
    this.setState({
      index: newIndex
    });
    cb();
  }

  getControlOffset = (aspectRatio) => {
    return (width, controlHeight) => {
      return AspectRatioCard.getControlOffset(width, controlHeight, aspectRatio);
    };
  }

  render() {
    const {
      children,
      title,
      isTouchDevice,
      onPreviousClick,
      onNextClick,
      cardAspectRatio,
      ...otherProps
    } = this.props;

    return (
      <IsBrowser withTransition placeHolder={<div className="carousel-placeholder" />}>
        <CardCarousel
          breakpoints={{
            '1600': 5,
            '1200': 4,
            '992': 4,
            '768': 3,
            '480': 3,
            '0': 2
          }}
          cardIndex={this.state.index}
          onPreviousClick={this.handlePrevNext(onPreviousClick)}
          onNextClick={this.handlePrevNext(onNextClick)}
          title={title}
          scrolling={isTouchDevice}
          paging
          getControlOffset={this.getControlOffset(cardAspectRatio)}
          {...otherProps}
        >
          {children}
        </CardCarousel>
      </IsBrowser>
    );
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/universal/components/Carousel/Carousel.js